import { useState } from 'react';
import { Plus } from 'lucide-react';
import { useParams } from 'react-router';

import { useCategories } from '@/api/category/use-categories';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import CategoryBox from '@/features/categories/category-box';
import CreateCategoryModal from '@/features/categories/create-category-modal/create-category-modal.tsx';
import AppContent from '@/layout/app-content';

const Categories = () => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const { projectId } = useParams();

  const { data: categories, isLoading } = useCategories(projectId);

  if (isLoading) {
    return (
      <AppContent title="Categories">
        <Card>
          <CardContent className="p-6">
            <div className="text-center">Loading categories...</div>
          </CardContent>
        </Card>
      </AppContent>
    );
  }

  return (
    <AppContent title="Categories">
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <div>
              <CardTitle>Categories</CardTitle>
              <CardDescription>Manage expense categories for your project</CardDescription>
            </div>
            <Button onClick={() => setIsCreateModalOpen(true)} data-icon="inline-end">
              Add Category
              <Plus className="size-3.5" />
            </Button>
          </div>
        </CardHeader>
      </Card>

      <div className="flex flex-col gap-2 text-xs">
        <h2 className="text-base mb-1">All Categories</h2>
        {categories?.map((category) => (
          <CategoryBox key={category.uuid} projectId={projectId!} category={category} />
        ))}
        {!categories?.length && (
          <div className="text-center py-8">
            <CardTitle className="text-lg mb-2">No categories yet</CardTitle>
            <CardDescription>Create your first category to get started.</CardDescription>
          </div>
        )}
      </div>
      {isCreateModalOpen && <CreateCategoryModal onClose={() => setIsCreateModalOpen(false)} />}
    </AppContent>
  );
};

export default Categories;
